import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Icon } from "@azim-crm/icons";
import styles from "./Chip.module.css";
/**
 * Chip de filtro do Azim CRM.
 * Botão em formato pill, com estado ativo (`active`) e contador opcional.
 */
export function Chip({ label, icon, active = false, count, onClick, disabled, className }) {
    const cls = [styles.chip, active ? styles.active : "", className ?? ""].filter(Boolean).join(" ");
    return (_jsxs("button", { type: "button", className: cls, "aria-pressed": active, onClick: onClick, disabled: disabled, children: [icon && _jsx(Icon, { name: icon, size: 14 }), _jsx("span", { children: label }), count != null && _jsx("span", { className: styles.count, children: count })] }));
}
//# sourceMappingURL=Chip.js.map